import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';
import { getAuthState } from './getAuthState';

export const SITE_CONFIG_REQUEST = 'SITE_CONFIG_REQUEST';
export const SITE_CONFIG_SUCCESS = 'SITE_CONFIG_SUCCESS';
export const SITE_CONFIG_FAILURE = 'SITE_CONFIG_FAILURE';
export const SITE_CONFIG_UNLICENSED = 'SITE_CONFIG_UNLICENSED';

function request() {
  return {
    type: SITE_CONFIG_REQUEST
  };
}

function receive(data) {
  return {
    type: SITE_CONFIG_SUCCESS,
    authMode: data.authMode
  };
}

function reject() {
  return {
    type: SITE_CONFIG_FAILURE
  };
}

function unlicensed() {
  return {
    type: SITE_CONFIG_UNLICENSED
  };
}

export function getSiteConfig() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getSiteConfig()
      .then((response) => {
        dispatch(receive(response.data));
        dispatch(getAuthState());
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(handleException(error, unlicensed, false, false));
          } else {
            dispatch(handleException(error, reject, false, false));
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false, false));
        }
      });
    return promise();
  };
}
